<style lang="less" scoped>
  .content {
    flex-direction: column;
  }
  .table-layout {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .table-area {
    height: 180px;
  }
  .arrow-row {
    position: relative;
    padding: 8px 0;
    text-align: center;
    min-height: 45px;
  }
  .progress {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .number-layout {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 60px;
    .number {
      position: absolute;
      font-size: 84px;
      padding: 0 16px;
      &:nth-of-type(1),
      &:nth-of-type(3) {
        font-size: 36px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #fff800;
        opacity: 0.5;
        top: 50%;
        transform: translateY(-50%)
      }
      &:nth-of-type(1) {
        left: 0;
      }
      &:nth-of-type(3) {
        right: 0;
      }
    }
  }
  .keypad-area {
    width: 100%;
  }
</style>

<template lang="pug">
  .std-layout
    .header
      header-component(
        @click-stop='redirectBack'
        @click-complete='done')
    .content
      .table-layout
        .up-arrow.arrow-row
          up-arrow-component(
            @click.native='prevPage'
            v-if='page > 0')
          progress-component.progress(
            :current='current + 1'
            :max='answerCount'
            :unit='"자리"')
        .table-area
          table-component(
            :page='page'
            :units='units'
            :focus='focus'
            :controls='true'
            :input='payload'
            @click-clear='clearColumn($event)'
            @click-column='clickedColumn($event)')
        .down-arrow.arrow-row
          down-arrow-component(
            @click.native='nextPage'
            v-if='page < groupCount - 1')
      .keypad-area
        keypad-component(@click='keypadClicked($event)')
    .footer
      footer-component(
        :time='time'
        @click-next='next'
        @click-prev='prev')
</template>

<script>
import HeaderComponent from '@/components/header/stop_submit';
import ProgressComponent from '@/components/current_max_progress';
import UpArrowComponent from '@/components/up_arrow';
import DownArrowComponent from '@/components/down_arrow';
import TableComponent from '@/components/number_table';
import KeypadComponent from '@/components/keypad';
import FooterComponent from '@/components/footer/timer_arrow';

export default {
  data() {
    return {
      payload: [],
      current: 0,
      focus: 0,
      time: 0,
      page: 0,
      score: 0,
    };
  },
  computed: {
    answer() {
      return this.$store.state.app.answer;
    },
    answerCount() {
      return this.answer.length;
    },
    units() {
      return this.$store.state.app.units;
    },
    pageCount() {
      return Math.ceil(this.answer.length / 24);
    },
    endTime() {
      return this.$store.state.app.recall * 60;
    },
    groupCount() {
      const count = Math.ceil(this.answer.length / 24);
      return count;
    },
  },
  methods: {
    clearColumn() {
      this.$set(this.payload, this.current, []);
    },
    done() {
      this.$store.commit('setInput', this.payload);
      // 리콜에서 걸린 시간은 성적에 영향을 미치지 않음.
      // this.$store.commit('setUsedTime', this.time);
      this.$router.replace({ name: 'TrainingNumberResult' });
    },
    redirectBack() {
      this.$router.go(-1);
    },
    keypadClicked(number) {
      this.insert(number);
      if (this.payload[this.current].length >= this.units) {
        this.setCurrent(this.current + 1);
        this.setFocus(this.current % 24);
        this.setPage(Math.floor(this.current / 24));
      }
    },
    insert(number) {
      const maxLength = this.units; // 이 안에 들어갈 수 있는 최대 글자 수
      const strLength = this.payload[this.current].length;
      if (strLength >= maxLength) {
        this.clearColumn();
      }
      if (typeof this.payload[this.current] === 'object') {
        if (this.payload[this.current].length < this.answer[this.current].length) {
          const obj = this.payload[this.current];
          obj.push(number);
          this.$set(this.payload, this.current, obj);
        }
      }
    },
    progressTimer() {
      this.time += 1;
      if (this.time >= this.endTime) {
        this.done();
      }
    },
    setFocus(focus) {
      let result = focus;
      if (focus >= this.answer.length) {
        result = this.answer.length - 1;
      } else if (focus < 0) {
        result = 0;
      }
      this.focus = result;
    },
    setPage(page) {
      let result = page;
      if (page >= this.pageCount) {
        result = this.pageCount - 1;
      } else if (page < 0) {
        result = 0;
      }
      this.page = result;
    },
    setCurrent(current) {
      let result = current;
      if (current >= this.answer.length) {
        result = this.answer.length - 1;
      } else if (current < 0) {
        result = 0;
      }
      this.current = result;
    },
    next() {
      this.setCurrent(this.current + 1);
      this.setFocus(this.current % 24);
      this.setPage(Math.floor(this.current / 24));
    },
    prev() {
      this.setCurrent(this.current - 1);
      this.setFocus(this.current % 24);
      this.setPage(Math.floor(this.current / 24));
    },
    nextPage() {
      this.setPage(this.page + 1);
      this.setCurrent(this.page * 24);
      this.setFocus(this.current % 24);
    },
    prevPage() {
      this.setCurrent((this.page * 24) - 1);
      this.setFocus(this.current % 24);
      this.setPage(this.page - 1);
    },
    clickedColumn(index) {
      const maxColumnCount = 24;
      const page = this.page;
      const current = (maxColumnCount * page) + index;
      this.setCurrent(current);
      this.setFocus(index);
    },
  },
  created() {
    for (let i = 0; i < this.answer.length; i += 1) {
      this.payload[i] = [];
    }
    window.intervalID = setInterval(this.progressTimer, 1000);
  },
  beforeDestroy() {
    clearInterval(window.intervalID);
  },
  components: {
    HeaderComponent,
    ProgressComponent,
    TableComponent,
    UpArrowComponent,
    DownArrowComponent,
    KeypadComponent,
    FooterComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/training/number/recall.vue